import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './routes/routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
